import Concept from "../images/concept.jpg";
import Matches from "../images/m.jpg";
import Premium from "../images/p.jpg";

export const images = [
  { 
  title: "Concept", 
  subtitle: "B Connected is about making business contact much easier and more friendly. It is about finding your perfect business connection in a matter of seconds.", 
  img: Concept },
  {
    title: "Connections",
    subtitle: "We create a connection between you and people that have a large array of similar interests.",
    img: Matches,
  },
  {
    title: "Chat",
    subtitle: "Now that you are connected, you can immediately start chatting with your newly established business connection",
    img: Premium,
  },
];